import * as Yup from 'yup'

const cmsFeaturedSellerSearchFormSchema = Yup.object().shape({
  closet_id: Yup.number().required('Required')
})

export default cmsFeaturedSellerSearchFormSchema
